<div id="html2Pdf" class="rightPanel h-100 position-relative" #pdfContent>
  <div>
    <div class="actionBar">
      <span *ngIf="showCheck">
        Individual Node Report
        <mat-slide-toggle [(ngModel)]="isChecked" (change)="onToggleChange($event)"></mat-slide-toggle>
      </span>

      <ng-select class="me-2 w-8" #deploymentFilter title="Select Deployment" [clearable]="false"
        [(ngModel)]="selectedDepMetric" id="depFilter" name="DeploymentFilter"
        (ngModelChange)="deploymentFilterApplied()">
        <ng-option selected value="all">All</ng-option>
        <ng-option *ngFor="let dep of deployments" [value]="dep">
          {{ dep }}
        </ng-option>
      </ng-select>

      <ng-select class="me-2 w-15 ngselect" #metricFilter name="metricFilter" [(ngModel)]="selectedMetric"
        (ngModelChange)="optionClicked()" [clearable]="false">
        <ng-option selected value="all">All Charts</ng-option>
        <ng-option value="SessionGraph" *ngIf="isVdi && selectedDepMetric != 'all'"><span title="User Sessions">User
            Sessions</span>
        </ng-option>
        <ng-option value="JobSummary" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job Summary">Job
            Summary</span>
        </ng-option>
        <ng-option value="JobCompleted" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job Completed">Job
            Completed</span>
        </ng-option>
        <ng-option value="JobDataCount" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job Submit Count">Job
            Submit Count</span>
        </ng-option>
        <ng-option value="JobByApplication" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Job By Application">Job By Application</span>
        </ng-option>
        <ng-option value="JobByNodes" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job By Nodes">Job By
            Nodes</span>
        </ng-option>
        <ng-option value="JobByNodeGroup" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Job By Node Group">Job By Node Group</span>
        </ng-option>
        <ng-option value="RunningQueuedJobsPerNodeGroup" *ngIf="!isVdi && selectedDepMetric != 'all'">
          <span title="Job By Node Group By Interval">Job By Node Group By Interval</span>
        </ng-option>
        <ng-option value="JobWaitTime" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job Wait Time">Job Wait
            Time</span>
        </ng-option>
        <ng-option value="JobByUser" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job By Users">Job By
            Users</span>
        </ng-option>
        <ng-option value="JobByGroup" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job By Groups">Job By
            Groups</span>
        </ng-option>
        <ng-option value="JobByTags" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Job By Tags">Job By
            Tags</span>
        </ng-option>
        <ng-option value="JobByTagsPerDay" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Job By Tags By Interval">Job By Tags By Interval</span></ng-option>
        <ng-option value="StorageUsage" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Storage Usage">Storage
            Usage</span>
        </ng-option>
        <ng-option value="CoresByApplication" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Cores By Application">Cores By Application</span>
        </ng-option>
        <ng-option value="CoreHoursByUsers" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Core Hours By Users">Core Hours By Users</span>
        </ng-option>
        <ng-option value="CoreHoursByGroups" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Core Hours By Groups">Core Hours By Groups</span>
        </ng-option>
        <ng-option value="CoreUsage" *ngIf="!isVdi && selectedDepMetric != 'all'"><span title="Avg Core Usage">Avg Core
            Usage</span>
        </ng-option>
        <ng-option value="NodeAvailability" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Node Availability">Node Availability</span>
        </ng-option>
        <ng-option value="NodeUtilization" *ngIf="selectedDepMetric != 'all'">
          Avg Node Utilization
        </ng-option>
        <ng-option value="SingleNodeUtilization" *ngIf="selectedDepMetric != 'all'"><span
            title="Single Node Utilization">Single Node Utilization</span>
        </ng-option>
        <ng-option value="ActiveSessions" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="Active Sessions">Active Sessions</span>
        </ng-option>
        <ng-option value="RAMUtilization" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="RAM Utilization">RAM Utilization</span>
        </ng-option>
        <ng-option value="CPUUtilization" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="CPU Utilization">CPU Utilization</span>
        </ng-option>
        <ng-option value="GpuMemoryUtilization" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="GPU Memory Utilization">GPU Memory Utilization</span>
        </ng-option>
        <ng-option value="NetworkUtilization" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="Network Utilization">Network Utilization</span>
        </ng-option>
        <ng-option value="AllUserSessions" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="All User Sessions">All User Sessions</span>
        </ng-option>
        <ng-option value="AllUserSessionsPerHost" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="All User Sessions Per Host">All User Sessions Per Host</span>
        </ng-option>
        <ng-option value="NodeStartStopStatus" *ngIf="isVdi || (selectedDepMetric == 'all' && !allHpc)"><span
            title="Node Start/Stop Status">Node Start/Stop Status</span>
        </ng-option>
        <ng-option value="IndividualNodeNetworkUtilization" *ngIf="isVdi && selectedDepMetric != 'all'"><span
            title="Individual Node Network Utilization">Individual Node Network Utilization</span>
        </ng-option>
        <ng-option value="PrimeNonPrimeCoreUsage" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Prime-NonPrime Core Usage">Prime-NonPrime Core Usage</span>
        </ng-option>
        <ng-option value="NodeUtilizationByNodeGroup" *ngIf="selectedDepMetric != 'all'"><span
            title="Utilization By Node Group">Utilization By Node Group</span>
        </ng-option>
        <ng-option value="HpcUnitsConsumed" *ngIf="!isVdi">
          <span title="HPC Units Consumed">HPC Units Consumed</span>
        </ng-option>
        <ng-option value="CpuUsageByNodes" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="CPU Usage By Nodes">CPU Usage By Nodes</span>
        </ng-option>
        <ng-option value="CpuUsageByNodeGroups" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="CPU Usage By Node Groups">CPU Usage By Node Groups</span>
        </ng-option>
        <ng-option value="CoreUsageByNodes" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Core Usage By Nodes">Core Usage By Nodes</span>
        </ng-option>
        <ng-option value="CoreUsageByNodeGroups" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Core Usage By Node Groups">Core Usage By Node Groups</span>
        </ng-option>
        <ng-option value="JobDurationsByDay" *ngIf="!isVdi && selectedDepMetric != 'all'"><span
            title="Job Duration By Day">Job Duration By Day</span>
        </ng-option>
      </ng-select>

      <ng-select class="me-2 w-8" title="Select Metric" [(ngModel)]="singleNodeSelectedMetric" *ngIf="isChecked == true"
        style="width: auto">
        <ng-option value="all" [disabled]="nodeGraphType == 'network'">
          All Charts
        </ng-option>
        <ng-option value="{{ nodeGraphType }}">{{ nodeGraphType }}</ng-option>
      </ng-select>

      <form [formGroup]="myForm">
        <ng-template [ngIf]="selectedMetric == 'JobByUser'" style="max-height: 33px">
          <ng-multiselect-dropdown class="me-2" name="userNames" [placeholder]="'Choose Users'"
            [settings]="dropdownSettings" [data]="userNames" formControlName="userNames" [disabled]="false">
          </ng-multiselect-dropdown>
        </ng-template>

        <ng-template [ngIf]="selectedMetric == 'CoreHoursByUsers'">
          <ng-multiselect-dropdown class="me-2" name="coreHourUserNames" [placeholder]="'Choose Users'"
            [settings]="coreHoursDropdownSettings" [data]="coreHourUserNames" formControlName="coreHourUserNames"
            [disabled]="false">
          </ng-multiselect-dropdown>
        </ng-template>

        <ng-template [ngIf]="
            selectedMetric == 'JobByGroup' ||
            selectedMetric == 'CoreHoursByGroups'
          ">
          <ng-multiselect-dropdown class="me-2" name="userGroupNames" [placeholder]="'Choose Groups'"
            [settings]="dropdownSettings" [data]="userGroupNames" formControlName="userGroupNames" [disabled]="false">
          </ng-multiselect-dropdown>
        </ng-template>

        <ng-template [ngIf]="
            selectedMetric == 'JobByTags' || selectedMetric == 'JobByTagsPerDay'
          ">
          <ng-multiselect-dropdown class="me-2" name="jobTags" [placeholder]="'Choose Tags'"
            [settings]="dropdownSettings" [data]="jobTags" formControlName="jobTags" [disabled]="false">
          </ng-multiselect-dropdown>
        </ng-template>
      </form>

      <ng-select class="me-2 w-10" #userFilter id="userFilter" title="Choose Only Single User" name="UserFilter"
        *ngIf="selectedMetric == 'SessionGraph'" [disabled]="false" [(ngModel)]="userFilterValue">
        <ng-option selected value="none">Select User</ng-option>
        <ng-option *ngFor="let user of userNamesForSessionGraph" [value]="user">
          {{ user }}
        </ng-option>
      </ng-select>
      <ng-select class="me-2 w-10" #workstationFilter title="Choose Only Single Node" name="workstationFilter"
        id="workstationFilter" [(ngModel)]="wsValue" *ngIf="
          selectedMetric == 'SingleNodeUtilization' ||
          selectedMetric == 'IndividualNodeNetworkUtilization'
        ">
        <ng-option selected value="none">Select Workstation</ng-option>
        <ng-option *ngFor="let ws of wsNames" [value]="ws">{{ ws }}</ng-option>
      </ng-select>

      <ng-select class="me-2 w-10" #nodeGroupFilter title="Choose any one Node Group" name="nodeGroupFilter"
        id="nodeGroupFilter" [(ngModel)]="nodeGroupValue" *ngIf="selectedMetric == 'NodeUtilizationByNodeGroup'">
        <ng-option selected value="none">Select Node Group</ng-option>
        <ng-option *ngFor="let ws of nodeGroups" [value]="ws">{{
          ws
          }}</ng-option>
      </ng-select>

      <ng-select id="" name="chartType" [(ngModel)]="activeChartType"
        *ngIf="selectedMetric != 'all' && availableChartTypes.length > 1" [clearable]="false" class="ngselect me-2"
        style="margin:4px">
        <ng-option *ngFor="let chart of availableChartTypes" value="{{ chart?.toLowerCase() }}">
          {{ chart }}
        </ng-option>
      </ng-select>

      <input class="me-2 inputbar" #dateFilter container="body" placement="right auto"
        triggers="hover" ngbTooltip="Strictly add 'hr' with value if value is in hours or add 'days' with value if value is in days"
        name="dateFilter" [(ngModel)]="dateFilterValue" [matAutocomplete]="queue" />

      <mat-autocomplete #queue="matAutocomplete">
        <mat-option value="1 days">Last 24hrs</mat-option>
        <mat-option value="7 days" selected>7 Days</mat-option>
        <mat-option value="30 days">30 Days</mat-option>
        <mat-option value="90 days">90 Days</mat-option>
        <mat-option value="180 days">180 Days</mat-option>
        <mat-option value="365 days">1 Year</mat-option>
        <mat-option value="custom">Custom</mat-option>
      </mat-autocomplete>

      @if(dateFilter.value == 'custom'){
        <input matInput [min]="prevDate" [max]="todayDate" [owlDateTimeTrigger]="dt8" [owlDateTime]="dt8"
          [selectMode]="'range'" [formControl]="dateTimePeriod" class="me-2 inputbar" placeholder="Choose period">
        <owl-date-time [pickerType]="'calendar'" #dt8></owl-date-time>
      }

      <ng-select [disabled]="
        [
          'JobSummary',
          'JobCompleted',
          'JobWaitTime',
          'JobByUser',
          'JobByGroup',
          'JobByApplication',
          'JobByNodes',
          'JobByNodeGroup',
          'CoresByApplication',
          'CoreHoursByUsers',
          'JobByTags',
          'CpuUsageByNodes',
          'CpuUsageByNodeGroups',
          'CoreUsageByNodes',
          'CoreUsageByNodeGroups',
          'JobDurationsByDay',
          'JobByTagsPerDay',
          'RunningQueuedJobsPerNodeGroup'
        ].includes(selectedMetric) || dateFilter.value.includes('hr')
      " [(ngModel)]="granularityValue" class="me-2 w-8" title="Choose Granularity" name="granularity"
        [clearable]="false" #granularity>
        <ng-option *ngFor="
          let gran of getGranularityForMetric(
            selectedMetric,
            dateFilter.value
          )
        " [value]="gran">
          {{ gran }}
        </ng-option>
      </ng-select>

      <button class="actionBtn" [disabled]="disableApplyFilter" triggers="hover" ngbTooltip="Apply filters" (click)="
          applyFilters(
            metricFilter?.value,
            dateFilter?.value,
            granularity?.value,
            wsValue,
            userFilterValue
          );
          disableButton()
        ">
        <span class="bi bi-check-circle"></span>
      </button>

      <button type="button" class="actionBtn" [class.gray]="disableApplyFilter" [disabled]="disableApplyFilter"
        (click)="resetFilter(); disableButton()" triggers="hover" ngbTooltip="Reset applied Filter" #btnResetFilter>
        <span class="bi bi-x-lg text-danger"></span>
      </button>

      <div class="date-filter-container">
        <div class="h-100" ngbDropdown container="body">
          <button type="button" class="actionBtn" triggers="hover" ngbTooltip="Download" ngbDropdownToggle>
            <i class="bi bi-download"></i>
          </button>
          <div ngbDropdownMenu>
            <button *ngIf="selectedDepMetric != 'all' && isVdi != true" ngbDropdownItem title="Download Job Info"
              (click)="downloadJobData()">
              Job Info
            </button>
            <button ngbDropdownItem *ngIf="
              selectedMetric != 'SessionGraph' &&
              selectedMetric != 'AllUserSessions' &&
              selectedMetric != 'AllUserSessionsPerHost' &&
              selectedMetric != 'NodeStartStopStatus'
            " title="Download Current Chart Data" (click)="
              applyFilters(
                metricFilter?.value,
                dateFilter?.value,
                granularity?.value,
                wsValue,
                userFilterValue,
                true
              )
            ">
              Chart Data
            </button>
            <button ngbDropdownItem title="Export shown charts as PDF" (click)="generatePdf(false)">
              Export to PDF
            </button>
            <button ngbDropdownItem title="Share shown charts as PDF by email" (click)="generatePdf(true)">
              Send Report
            </button>
            <button type="button" ngbDropdownItem title="Download session details in csv file" style="margin-left: 0"
              (click)="downloadSessionInfo()" #btnDownloadJob>
              Session Info
            </button>
            <button ngbDropdownItem title="Download node utilization data points in csv file"
              (click)="downloadNodeUtilization()">
              Node Utilization
            </button>
          </div>
        </div>

        <button type="button" class="actionBtn" (click)="refreshComponent()" triggers="hover" ngbTooltip="Refresh Details">
          <span class="bi bi-arrow-clockwise"></span>
        </button>
      </div>
    </div>

    <div class="charts centerCharts" *ngIf="showError" style="margin: 15%">
      <p>
        {{ errorMessage }}
      </p>
    </div>

    <!--<p>HPC Graphs</p>-->
    <!--<div class="charts" *ngIf="!fromDashboard && allHpc && selectedDepMetric == 'all'">-->
    <div class="charts" *ngIf="selectedMetric == 'all' && allHpc && selectedDepMetric == 'all'">
      <div class="singleChart">
        <canvas baseChart id="allJobs" style="height: 35vh; width: 30vw" [data]="allJobsData" [type]="allJobsType"
          [options]="allJobsOptions" [plugins]="allJobsPlugins" [colors]="allJobsColors">
        </canvas>
      </div>
      <div>
        <canvas id="completedJobs" baseChart style="height: 35vh; width: 30vw" [data]="jobsSummaryData"
          [type]="jobsSummaryType" [options]="jobsSummaryOptions" [plugins]="jobsSummaryPlugins">
        </canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="jobCountByDayData" [options]="jobCountByDayOptions"
          [type]="nodeUtilizationType"></canvas>
      </div>
    </div>

    <!--<p>VDI Graphs</p>
  <div class="charts" *ngIf="!fromDashboard && selectedDepMetric == 'all' && allVdi">-->
    <div class="charts" *ngIf="selectedDepMetric == 'all' && selectedMetric == 'all' && allVdi">
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataTotal" [options]="nodeUtilizationOptionsTotal"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataOffice" [options]="nodeUtilizationOptionsTotalOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataNonOffice" [options]="nodeUtilizationOptionsNonOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
    </div>

    <!--<p>Node utilization graph</p>-->
    <div class="charts" *ngIf="
      selectedMetric == 'NodeUtilization' ||
      selectedMetric == 'SingleNodeUtilization' ||
      selectedMetric == 'NodeUtilizationByNodeGroup'
    ">
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataTotal" [options]="nodeUtilizationOptionsTotal"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataOffice" [options]="nodeUtilizationOptionsTotalOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataNonOffice" [options]="nodeUtilizationOptionsNonOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
    </div>

    <!--<p>Mixed Deployment Graphs</p>-->
    <div class="charts" *ngIf="mixedDep && selectedMetric == 'all' && selectedDepMetric == 'all'">
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart id="allJobs" style="height: 35vh; width: 30vw" [data]="allJobsData" [type]="allJobsType"
          [options]="allJobsOptions" [plugins]="allJobsPlugins" [colors]="allJobsColors">
        </canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas id="completedJobs" baseChart [data]="jobsSummaryData" [type]="jobsSummaryType"
          [options]="jobsSummaryOptions" [plugins]="jobsSummaryPlugins" [colors]="allJobsColors">
        </canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="jobCountByDayData" [options]="jobCountByDayOptions"
          [type]="nodeUtilizationType"></canvas>
      </div>
    </div>
    <br />
    <div class="charts" *ngIf="mixedDep && selectedMetric == 'all' && selectedDepMetric == 'all'">
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataTotal" [options]="nodeUtilizationOptionsTotal"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataOffice" [options]="nodeUtilizationOptionsTotalOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
      <div style="height: 35vh; width: 30vw">
        <canvas baseChart [data]="nodeUtilizationDataNonOffice" [options]="nodeUtilizationOptionsNonOffice"
          [type]="nodeUtilizationType"></canvas>
      </div>
    </div>

    <!--<p>Overview of graphs</p>-->
    <div *ngIf="selectedDepMetric != 'all' && selectedMetric == 'all'">
      <div *ngIf="isVdi">
        <div class="charts centerCharts">
          <div style="height: 35vh; width: 30vw">
            <canvas baseChart [data]="nodeUtilizationDataTotal" [options]="nodeUtilizationOptionsTotal"
              [type]="nodeUtilizationType"></canvas>
          </div>
          <div style="height: 35vh; width: 30vw">
            <canvas baseChart [data]="nodeUtilizationDataOffice" [options]="nodeUtilizationOptionsTotalOffice"
              [type]="nodeUtilizationType"></canvas>
          </div>
          <div style="height: 35vh; width: 30vw">
            <canvas baseChart [data]="nodeUtilizationDataNonOffice" [options]="nodeUtilizationOptionsNonOffice"
              [type]="nodeUtilizationType"></canvas>
          </div>
        </div>
        <!--<p>Active Sessions per deployment</p>
      <hr />
      <div class="charts centerCharts">
        <div style="height: 35vh; width: 30vw">
          <canvas baseChart
                  [data]="activeSessionsByProfileDataTotal"
                  [options]="activeSessionsByProfileOptions"
                  [type]="nodeUtilizationType"></canvas>
        </div>
        <div style="height: 35vh; width: 30vw">

        </div>
        <div style="height: 35vh; width: 30vw">

        </div>
      </div>-->
      </div>
      <div *ngIf="!isVdi">
        <div class="charts" *ngIf="selectedMetric == 'all'">
          <div class="chart">
            <canvas baseChart id="allJobs" height="220" width="355" [data]="allJobsData" [type]="allJobsType"
              [options]="allJobsOptions" [plugins]="allJobsPlugins" [colors]="allJobsColors">
            </canvas>
          </div>
          <div class="chart">
            <canvas baseChart id="completedJobs" height="220" width="350" [data]="jobsSummaryData"
              [type]="jobsSummaryType" [options]="jobsSummaryOptions" [plugins]="jobsSummaryPlugins">
            </canvas>
          </div>
          <div class="chart">
            <canvas baseChart id="storageUsage" height="220" width="350" [data]="storageChartData"
              [options]="storageChartOptions" [type]="storageChartType" [plugins]="storageChartPlugins">
            </canvas>
          </div>
        </div>
        <br />
        <div class="charts mt-5" *ngIf="selectedMetric == 'all'">
          <div class="chart">
            <canvas baseChart id="avgCoreUsage" height="220" width="355" [data]="coresPerDayData"
              [options]="coresPerDayOptions" [type]="coresPerDayType" [plugins]="coresPerDayPlugins">
            </canvas>
          </div>
          <div class="chart">
            <canvas id="jobDataCount" baseChart height="220" width="350" [data]="jobCountChartData"
              [options]="jobCountChartOptions" [type]="jobCountChartType" [plugins]="jobCountChartPlugins">
            </canvas>
          </div>
          <div class="chart">
            <canvas id="jobByApplication" baseChart height="220" width="350" [data]="jobByApplicationData"
              [options]="jobByApplicationOptions" [type]="jobByApplicationType" [plugins]="jobByApplicationPlugins">
            </canvas>
          </div>
        </div>
      </div>
    </div>

    <!--<p>Specific report like cpu,ram,gpu</p>-->
    <div class="charts" *ngIf="
      !isChecked &&
      !activeSessionsPerDep &&
      (selectedMetric == 'RAMUtilization' ||
        selectedMetric == 'CPUUtilization' ||
        selectedMetric == 'GpuMemoryUtilization' ||
        selectedMetric == 'NetworkUtilization')
    ">
      <div>
        <div style="height: 60vh; width: 60vw">
          <canvas baseChart [data]="specificUtilizationData" [options]="specificUtilizationOptions"
            [type]="nodeUtilizationType"></canvas>
        </div>
      </div>
    </div>

    <!--<p>Active Sessions per deployment</p>-->
    <div class="charts" *ngIf="
      (fromDashboard && activeSessionsPerDep) ||
      selectedMetric == 'ActiveSessions'
    ">
      <div>
        <div style="height: 60vh; width: 60vw">
          <canvas baseChart [data]="activeSessionsByProfileData" [options]="activeSessionsByProfileOptions"
            [type]="nodeUtilizationType"></canvas>
        </div>
      </div>
    </div>

    <!--<p>HPC Units Consumed</p>-->
    <div class="charts" *ngIf="selectedMetric == 'HpcUnitsConsumed'">
      <div>
        <div style="height: 60vh; width: 69vw">
          <canvas baseChart [data]="hpcUnitsConsumedDataTotal" [options]="hpcUnitsConsumedOptions"
            [type]="nodeUtilizationType"></canvas>
        </div>
      </div>
    </div>

    <div *ngIf="
      selectedMetric == 'AllUserSessions' &&
      timelineChartData.dataTable.length > 1
    ">
      <div style="height: 60vh">
        <!--<google-chart [data]="timelineChartData"></google-chart>-->
        <google-chart #chart id="chart_div" type="Timeline" [data]="timelineChartData.dataTable" [height]="chartHeight"
          [width]="chartWidth" [options]="timelineChartData.options">
        </google-chart>
      </div>
    </div>

    <div *ngIf="selectedMetric == 'AllUserSessionsPerHost'">
      <div *ngFor="let d of timelineChartDataByHostToShow">
        <p>Host Name : {{ d.title }}</p>
        <google-chart #chart id="chart_div" type="Timeline" [data]="d.data.dataTable" [height]="chartHeight"
          [width]="chartWidth" [options]="d.data.options">
        </google-chart>
      </div>
    </div>

    <div *ngIf="
      selectedMetric == 'NodeStartStopStatus' &&
      nodeStatusTimelineChartData.dataTable.length > 1
    ">
      <div style="height: 60vh">
        <!--<google-chart [data]="timelineChartData"></google-chart>-->
        <google-chart #chart id="chart_div" type="Timeline" [data]="nodeStatusTimelineChartData.dataTable"
          [height]="chartHeight" [width]="chartWidth" [options]="nodeStatusTimelineChartData.options">
        </google-chart>
      </div>
    </div>

    <!--<p>Single node utilization report</p>-->
    <div *ngIf="
      isChecked &&
      (selectedMetric == 'RAMUtilization' ||
        selectedMetric == 'CPUUtilization' ||
        selectedMetric == 'GpuMemoryUtilization' ||
        selectedMetric == 'NetworkUtilization')
    " class="row card-group text-center">
      <div class="col-4" *ngFor="let d of chartData">
        <div class="tablechart">
          <canvas baseChart [data]="d.dt" [options]="d.ot" [type]="nodeUtilizationType"></canvas>
        </div>
        <br />
      </div>
    </div>

    <div class="flex-grow-1 w-100">
      <div class="charts centerCharts" *ngIf="selectedMetric != 'all'">
        <!--<p>User session graphs</p>-->
        <div *ngIf="selectedMetric == 'SessionGraph' && selectedUser != 'none'" class="col-md-12 row">
          <div class="col-md-6 p-1" style="max-height: 70vh; overflow-y: auto" #pdfContentSessionEndStart>
            <p>{{ selectedUser | titlecase }} Session Start / End Activity :</p>
            <google-chart *ngFor="let graph of graphStartEnd" #chart [type]="type" [data]="graph.data"
              [options]="graph.options" [columnNames]="colNames" [height]="chartHeight" [width]="chartWidth">
            </google-chart>
          </div>
          <div class="col-md-6 p-1" style="max-height: 70vh; overflow-y: auto" #pdfContentSessionConDisConnect>
            <p>
              {{ selectedUser | titlecase }} Session Connect / Disconnect Activity
              :
            </p>
            <google-chart *ngFor="let graph of graphConnDiscon" #chart [type]="type" [data]="graph.data"
              [options]="graph.options" [columnNames]="colNames" [height]="chartHeight" [width]="chartWidth">
            </google-chart>
          </div>
        </div>

        <!--<p> Job Summary Graph</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'JobSummary'">
          <canvas baseChart id="allJobs" style="width: 70vw; height: 60vh" [data]="allJobsData" [type]="allJobsType"
            [options]="allJobsOptions" [plugins]="allJobsPlugins" [colors]="allJobsColors">
          </canvas>
        </div>

        <!--<p>Completed Jobs</p>-->
        <div *ngIf="selectedMetric == 'JobCompleted'">
          <canvas id="completedJobs" baseChart style="width: 70vw; height: 60vh" [data]="jobsSummaryData"
            [type]="jobsSummaryType" [options]="jobsSummaryOptions" [plugins]="jobsSummaryPlugins">
          </canvas>
        </div>

        <!--<p>Storage Usage</p>-->
        <div class="singleChart d-flex w-80" *ngIf="selectedMetric == 'StorageUsage'">
          <div style="width: 75%; height: 60vh">
            <canvas id="storageUsage" baseChart 
            [data]="storageChartData"
            [options]="storageChartOptions" 
            [type]="storageChartType" 
            [plugins]="storageChartPlugins">
          </canvas>
          </div>
          <div *ngIf="!showDataLabelOptions(); else dataLabels"
            class="labelOptions d-flex flex-column justify-content-center"
            style="width: 25%">
          </div>
        </div>

        <!--<p>Core Usage</p>-->
        <div *ngIf="selectedMetric == 'CoreUsage'">
          <canvas id="avgCoreUsage" baseChart style="width: 69vw; height: 60vh" [data]="coresPerDayData"
            [options]="coresPerDayOptions" [type]="coresPerDayType" [plugins]="coresPerDayPlugins">
          </canvas>
        </div>

        <!--<p>Job Data Count</p>-->
        <div class="singleChart d-flex" *ngIf="selectedMetric == 'JobDataCount'">
          <canvas id="jobDataCount" baseChart style="width: 69vw; height: 60vh" [data]="jobCountChartData"
            [options]="jobCountChartOptions" [type]="jobCountChartType" [plugins]="jobCountChartPlugins">
          </canvas>
          <div *ngIf="!showDataLabelOptions(); else dataLabels"
            class="labelOptions d-flex flex-column justify-content-center"></div>
        </div>

        <!--<p>Individual Node Network Utilization</p>-->
        <div *ngIf="selectedMetric == 'IndividualNodeNetworkUtilization'">
          <canvas id="IndividualNodeNetworkUtilization" baseChart style="width: 69vw; height: 60vh"
            [data]="individualNodeNetworkUtilizationChartData" [options]="individualNodeNetworkUtilizationChartOptions"
            [type]="individualNodeNetworkUtilizationChartType" [plugins]="individualNodeNetworkUtilizationChartPlugins">
          </canvas>
        </div>

        <!--<p>Job by Application</p>-->
        <div class="singleChart d-flex w-80" *ngIf="selectedMetric == 'JobByApplication'">
          <div style="width: 75%; height: 60vh">
            <canvas 
              id="jobByApplication" 
              baseChart 
              [data]="jobByApplicationData"
              [options]="jobByApplicationOptions" 
              [type]="jobByApplicationType" 
              [plugins]="jobByApplicationPlugins">
          </canvas>
          </div>
          <div *ngIf="!showDataLabelOptions(); else dataLabels"
            class="labelOptions d-flex flex-column justify-content-center"
            style="width: 25%">
          </div>
        </div>

        <!--<p>Job By Wait Time</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'JobWaitTime'">
          <canvas id="jobWaitTime" baseChart style="width: 69vw; height: 60vh" [data]="jobWaitTimeChartData"
            [options]="jobWaitTimeChartOptions" [type]="jobWaitTimeChartType" [plugins]="jobWaitTimeChartPlugins">
          </canvas>
        </div>

        <!--<p>Node Availability</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'NodeAvailability'">
          <canvas id="nodeAvailability" baseChart style="width: 69vw; height: 60vh" [data]="nodeAvailabilityData"
            [options]="nodeAvailabilityChartOptions" [type]="nodeAvailabilityType" [plugins]="nodeAvailabilityPlugins">
          </canvas>
        </div>

        <!--<p>Job by users</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'JobByUser'">
          <canvas id="jobByUser" baseChart style="width: 69vw; height: 60vh" [data]="jobByUserChartData"
            [options]="jobByUserChartOptions" [type]="jobByUserChartType" [plugins]="jobByUserChartPlugins">
          </canvas>
        </div>

        <!--<p>Job by groups</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'JobByGroup'">
          <canvas id="jobByGroup" baseChart style="width: 69vw; height: 60vh" [data]="jobByGroupChartData"
            [options]="jobByGroupChartOptions" [type]="jobByGroupChartType" [plugins]="jobByGroupChartPlugins">
          </canvas>
        </div>

        <!--<p>Job by nodes</p>-->
        <div class="chart" *ngIf="selectedMetric == 'JobByNodes'">
          <canvas id="jobByNodes" baseChart style="width: 69vw; height: 60vh" [data]="jobByNodesData"
            [options]="jobByNodesOptions" [type]="jobByNodesType" [plugins]="jobByNodesPlugins">
          </canvas>
        </div>

        <div class="chart" *ngIf="selectedMetric == 'JobByNodeGroup'">
          <canvas id="jobByNodeGroup" baseChart style="width: 69vw; height: 60vh" [data]="jobByNodesData"
            [options]="jobByNodesOptions" [type]="jobByNodesType" [plugins]="jobByNodesPlugins">
          </canvas>
        </div>

        <!--<div>CPU Usage By Nodes in Bar Graph</div>-->
        <div class="chart" *ngIf="selectedMetric == 'CpuUsageByNodes'">
          <canvas id="cpuByNodes" baseChart class="chart-canvas" style="width: 69vw; height: 60vh"
            [data]="cpuUsageByNodesChartData" [options]="cpuUsageByNodesChartOptions" [type]="cpuUsageByNodesChartType"
            [plugins]="cpuUsageByNodesChartPlugins">
          </canvas>
        </div>

        <!--<div>CPU Usage By Node Groups in Bar Graph</div>-->
        <div class="chart" *ngIf="selectedMetric == 'CpuUsageByNodeGroups'">
          <canvas id="cpuByNodeGroups" baseChart style="width: 69vw; height: 60vh" class="chart-canvas"
            [data]="cpuUsageByNodeGroupsChartData" [options]="cpuUsageByNodeGroupsChartOptions"
            [type]="cpuUsageByNodeGroupsChartType" [plugins]="cpuUsageByNodeGroupsChartPlugins">
          </canvas>
        </div>

        <!--<div>Core Usage By Nodes in Bar Graph</div>-->
        <div class="chart" *ngIf="selectedMetric == 'CoreUsageByNodes'">
          <canvas id="cpuByNodes" baseChart class="chart-canvas" style="width: 69vw; height: 60vh"
            [data]="coreUsageByNodesChartData" [options]="coreUsageByNodesChartOptions"
            [type]="coreUsageByNodesChartType" [plugins]="coreUsageByNodesChartPlugins">
          </canvas>
        </div>

        <!--<div>Core Usage By Node Groups in Bar Graph</div>-->
        <div class="chart" *ngIf="selectedMetric == 'CoreUsageByNodeGroups'">
          <canvas id="cpuByNodeGroups" baseChart style="width: 69vw; height: 60vh" class="chart-canvas"
            [data]="coreUsageByNodeGroupsChartData" [options]="coreUsageByNodeGroupsChartOptions"
            [type]="coreUsageByNodeGroupsChartType" [plugins]="coreUsageByNodeGroupsChartPlugins">
          </canvas>
        </div>

        <!--<p>Job by tags</p>-->
        <div class="chart" *ngIf="selectedMetric == 'JobByTags'">
          <canvas id="jobByTags" baseChart style="width: 69vw; height: 60vh" [data]="jobByTagsData"
            [options]="jobByTagsOptions" [type]="jobByTagsType" [plugins]="jobByTagsPlugins">
          </canvas>
        </div>

        <!--<p>Cores by application</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'CoresByApplication'">
          <canvas id="coresByApplication" baseChart style="width: 69vw; height: 60vh"
            [data]="coresByApplicationChartData" [options]="coresByApplicationChartOptions"
            [type]="coresByApplicationChartType" [plugins]="coresByApplicationChartPlugins">
          </canvas>
        </div>

        <!--<p>Cores by users</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'CoreHoursByUsers' && activeChartType == 'bar'">
          <canvas id="coreHoursByUsers" baseChart style="width: 69vw; height: 60vh" [data]="coreHoursByUsersChartData"
            [options]="coreHoursByUsersChartOptions" [type]="coreHoursByUsersChartType"
            [plugins]="coreHoursByUsersChartPlugins">
          </canvas>
        </div>
        <div class="singleChart" *ngIf="selectedMetric == 'CoreHoursByUsers' && activeChartType == 'pie'">
          <canvas baseChart id="coreHoursByUsersPie" style="width: 70vw; height: 60vh" [data]="coreHoursByUsersPieData"
            [type]="coreHoursByUsersPieType" [options]="coreHoursByUsersPieOptions"
            [plugins]="coreHoursByUsersPiePlugins" [colors]="coreHoursByUsersPieColors">
          </canvas>
        </div>

        <!--<p>Cores by Groups</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'CoreHoursByGroups' && activeChartType == 'bar'">
          <canvas id="coreHoursByGroupsBar" baseChart style="width: 70vw; height: 60vh"
            [data]="coreHoursByGroupsChartData" [options]="coreHoursByGroupsChartOptions"
            [plugins]="coreHoursByGroupsChartPlugins" [type]="coreHoursByGroupsChartType"></canvas>
        </div>
        <div class="singleChart" *ngIf="selectedMetric == 'CoreHoursByGroups' && activeChartType == 'pie'">
          <canvas id="coreHoursByGroupsPie" baseChart style="width: 70vw; height: 60vh"
            [data]="coreHoursByGroupsPieData" [type]="coreHoursByGroupsPieType" [options]="coreHoursByGroupsPieOptions"
            [plugins]="coreHoursByGroupsPiePlugins" [colors]="coreHoursByGroupsPieColors">
          </canvas>
        </div>

        <!--<p>Prime and non-prime core usage</p>-->
        <div class="singleChart d-flex primeNonPrime" *ngIf="selectedMetric == 'PrimeNonPrimeCoreUsage'"
          style="overflow: auto;">
          <canvas id="primeCoreUsage" baseChart style="width: 1100px; height: 500px" [data]="primeCoreUsageChartData"
            [options]="primeCoreUsageChartOptions" [type]="primeCoreUsageChartType"
            [plugins]="primeCoreUsageChartPlugins">
          </canvas>
          <canvas id="nonPrimeCoreUsage" class="ms-4" baseChart style="width: 1100px; height: 500px"
            [data]="nonPrimeCoreUsageChartData" [options]="nonPrimeCoreUsageChartOptions"
            [type]="nonPrimeCoreUsageChartType" [plugins]="nonPrimeCoreUsageChartPlugins">
          </canvas>
        </div>

        <!--<p>JobDurationsByDay</p>-->
        <div class="chart" *ngIf="selectedMetric == 'JobDurationsByDay'">
          <canvas id="jobDurationsByDay" baseChart style="width: 69vw; height: 60vh" [data]="jobDurationsByDayData"
            [options]="jobDurationsByDayOptions" [type]="jobDurationsByDayType" [plugins]="jobDurationsByDayPlugins">
          </canvas>
        </div>

        <!--<p>Jobs by tags per day</p>-->
        <div class="singleChart d-flex" *ngIf="selectedMetric == 'JobByTagsPerDay'">
          <canvas id="jobByTagsPerDay" baseChart style="width: 69vw; height: 60vh" [data]="jobByTagsPerDayChartData"
            [options]="jobByTagsPerDayChartOptions" [type]="jobByTagsPerDayChartType"
            [plugins]="jobByTagsPerDayChartPlugins">
          </canvas>
          <div *ngIf="selectedMetric == 'JobByTagsPerDay' && !showDataLabelOptions(); else dataLabels"
            class="labelOptions d-flex flex-column justify-content-center"></div>
        </div>

        <!--<p>Running and Queued Jobs by Node Group</p>-->
        <div class="singleChart d-flex" *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'">
          <canvas id="RunningQueuedJobsPerNodeGroup" baseChart style="width: 69vw; height: 60vh"
            [data]="runningQueuedJobsPerNodeGroupChartData" [options]="runningQueuedJobsPerNodeGroupChartOptions"
            [type]="runningQueuedJobsPerNodeGroupChartType" [plugins]="runningQueuedJobsPerNodeGroupChartPlugins">
          </canvas>
          <div *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup' && !showDataLabelOptions(); else dataLabels"
            class="labelOptions d-flex flex-column justify-content-center"></div>
        </div>

        <!--<p>Prime - Non-Prime Hours Job Submission</p>-->
        <div class="singleChart" *ngIf="selectedMetric == 'PrimeNonPrimeJobSubmission'">
          <div>
            <div style="height: 60vh; width: 69vw">
              <canvas baseChart [data]="primeNonPrimeHoursJobsSubmissionData"
                [options]="primeNonPrimeHoursJobsSubmissionOptions"
                [type]="primeNonPrimeHoursJobsSubmissionType"></canvas>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!--<p>Show Tabular Data</p>-->
    <div></div>

    <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
      [fullScreen]="false" name="loadingGraphs">
      <p>Loading data ...</p>
    </ngx-spinner>
  </div>
</div>

<ng-template #dataLabels>
  <form action="" [formGroup]="graphDataLabelsForm" class="ms-4">
    <fieldset>
      <legend *ngIf="
          selectedMetric != 'JobByTagsPerDay' &&
          selectedMetric != 'JobByApplication' &&
          selectedMetric != 'RunningQueuedJobsPerNodeGroup'
        ">
        Show Data labels
      </legend>
      <legend *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'">Select Node Group</legend>
      <legend *ngIf="selectedMetric == 'JobByTagsPerDay'">Select Job Tag</legend>
      <legend *ngIf="selectedMetric == 'JobByApplication'">Select Application</legend>
      <div *ngIf="selectedMetric == 'JobDataCount'">
        <div>
          <input formControlName="jobCountSubmitted" (click)="updateChartDataLabel()" type="checkbox"
            name="submitted" />
          <label for="submitted"> Submitted</label>
        </div>
        <div>
          <input formControlName="jobCountSucceeded" (click)="updateChartDataLabel()" type="checkbox"
            name="succeeded" />
          <label for="succeeded"> Succeeded</label>
        </div>
        <div>
          <input formControlName="jobCountFailed" (click)="updateChartDataLabel()" type="checkbox" name="failed" />
          <label for="failed"> Failed</label>
        </div>
        <div>
          <input formControlName="jobCountCancelled" (click)="updateChartDataLabel()" type="checkbox"
            name="cancelled" />
          <label for="cancelled"> Cancelled</label>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'JobByTagsPerDay'" class="heightOverflowClass">
        <div formArrayName="jobByTagsPerDayForm">
          <div *ngFor="let tag of selectedJobTags; let i = index">
            <input type="checkbox" [formControlName]="i" (click)="tagChanged($event.target.checked, i)"
              [value]="tag.item_text" [name]="tag.item_text" />
            <label>{{ tag.item_text }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'JobByApplication'" class="heightOverflowClass">
        <div formArrayName="jobByApplicationPerDayForm">
          <div *ngFor="let app of applicationNames; let i = index">
            <input type="checkbox" [formControlName]="i" (click)="appsChanged($event.target.checked, i)" [value]="app"
              [name]="app" />
            <label>{{ app }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'RunningQueuedJobsPerNodeGroup'" class="heightOverflowClass">
        <div formArrayName="allNodeGroupsForm">
          <div *ngFor="let nodeGroup of selectedNodeGroups; let i = index">
            <label>
              <input type="checkbox" [formControlName]="i"
                (click)="nodeGroupChanged($event.target.checked, i, nodeGroup)">
              {{ nodeGroup }}
            </label>
            <!-- <input
              type="checkbox"
              [formControlName]="nodeGroup"
              (click)="nodeGroupChanged($event.target.checked, i, nodeGroup)"
              [value]="nodeGroup" />
            <label>{{ nodeGroup }}</label> -->
          </div>
        </div>
      </div>

      <div *ngIf="selectedMetric == 'StorageUsage'">
        <div>
          <input formControlName="storageUsage" (click)="updateChartDataLabel()" type="checkbox" name="usage">
          <label for="usage"> Usage</label>
        </div>
      </div>
      <div *ngIf="selectedMetric == 'CoresByApplication'">
        <div>
          <input formControlName="coresByApplication" (click)="updateChartDataLabel()" type="checkbox" name="cores" />
          <label for="cancelled"> Cores</label>
        </div>
      </div>
    </fieldset>
  </form>
</ng-template>